import React, { Component } from 'react';
import './Checkout.css'
import orderService from '../../services/order.service'
import Payment from '../payment/Payment';
import Timeline from '../timeline/Timeline'

declare var $;
declare var fbq;

class Checkout extends Component {
   constructor(props) {
     super(props)
     this.state = {
       total: 0,
       products: [],
       error: '',
       payment: false,
       paymentMethod: '',
       tip: '',
       loadingOrderText: false
     }
     this.createOrder = this.createOrder.bind(this);
     this.prepareOrderData = this.prepareOrderData.bind(this);
     this.getTotal = this.getTotal.bind(this);
     this.openPayment = this.openPayment.bind(this);
     this.handlePaymentData = this.handlePaymentData.bind(this)
     this.stepBack = this.stepBack.bind(this)
     this.nextStep = this.nextStep.bind(this)
     this.openCart = this.openCart.bind(this)
   }

    componentWillMount() {
      this.getTotal()
    }

    componentDidMount() {
      fbq('track', 'InitiateCheckout', {
        value: 0,
      });
    }

    prepareOrderData() {
      let products = JSON.parse(localStorage.getItem('products'))
      for( let product of products) {
        product.units = product.units;
        product.unit_price =  product.price;
        product.total_price = product.total_price;
        product.sale_type = 'U';
        product.toppings = [];
        delete product.price;
        delete product.image;
        delete product.description;
        delete product.name;
        delete product.original_price;
      }
     this.setState({
       products
     })
    }

    getTotal() {
      let amount = 0;
      for(let product of JSON.parse(localStorage.getItem('products')) ) {
         amount = amount + product.total_price;
      }
      this.setState({
        total: amount
      })
      this.prepareOrderData()
    }

    openPayment() {
      this.setState({
        payment: true
      })
    }

    handlePaymentData(data) {
     
      const prs = []
      data.products.forEach( (product) => {
        product.units = product.units;
        product.unit_price =  product.price;
        product.total_price = product.total_price;
        product.sale_type = 'U';
        product.toppings = [];
        delete product.price;
        delete product.is_avaliable;
        delete product.image;
        delete product.description;
        delete product.name;
        delete product.original_price;
        prs.push(product);
      })


      let total = data.total;
      let tip = data.tip;
      let paymentMethod = data.selectedMethod;
      let comment = data.comment
      const products = prs;
     // let products = JSON.parse(localStorage.getItem('products'));
      this.setState({
       total,
       tip,
       paymentMethod,
       products
     } , ()=> {   this.createOrder(total,tip,paymentMethod, comment)    })
    }

    async createOrder(total,tip, paymentMethod, comment) {
      let coupon = {}
      if(this.props.couponData.coupon_code) {
        coupon = {
          code: this.props.couponData.coupon_code,
          lng: this.props.selectedAddress.lng,
          lat: this.props.selectedAddress.lat
        }
      }
     let order = {
        address: this.props.selectedAddress,
        comments: comment,
        coupon,
        delivery: 0,
        delivery_date: '',
        device_type: 0,
        payment: {
          name: paymentMethod
        },
        platform: 0,
        products: this.state.products,
        store_id: 0,
        tip: tip,
        total_value: total,
        whims: [],
        token: localStorage.getItem('accessToken')
         ,
        source : "landing",
        source_value : window.navigator.userAgent
     }
     setTimeout(()=>{
       if(this.state.error === '') {
          this.setState({
            loadingOrderText: true
          })
       }
      }, 7000 )

     let response = await orderService.createOrder(order);
     response = response.data;
      if(response.application_user_id) {
         fbq('track', 'Purchase', {value: total, currency: 'MXN' });
         this.setState({
           loadingOrderText: false
         })
         this.nextStep();
      } else {
        let error = response.message_error.body.error.message;
        this.setState({
          error,
          loadingOrderText: false
        })
         this.nextStep();
      }
    }
    stepBack(s) {
      let step = this.props.step;
      step--
      this.props.continue(step)
    }

    nextStep() {
      let step = this.props.step;
      step++;
      this.props.continue(step)
    }

    openCart(e) {
      this.props.cart(e)
    }

  render() {
    var products = [];

    return (
      <section id="question" className="animated fadeIn">
        { this.state.payment &&
      <div className="container">
       <div className="row">
         <div className="text-center">
           <div className="row">
             <div className="col-md-4 col-lg-4 col-xs-10 col-center-block">
               <p className="tag">Dirección de entrega: </p>
               <div className="checkout-box">
                 <div className="row">
                   <div className="col-md-2">
                       <i className="fa fa-map-marker" aria-hidden="true"></i>
                   </div>
                   <div className="col-md-10 col-md-pull-1 ">
                     <span>{this.props.selectedAddress.address}</span>
                  { this.props.selectedAddress.description &&  <p>{this.props.selectedAddress.description}</p> }
                  { !this.props.selectedAddress.description &&  <p>Sin descripcion</p> }
                   </div>
                 </div>
               </div>
               <p className="tag">Productos:</p>
                    {products}
               <p className="tag">Valor del servicio: $0</p>
                 <p className="tag total">Total de la orden: {this.state.total}</p>
             </div>
           </div>
              <p className="error animated tada">{this.state.error}</p>
             <p className="animated tada">Aun estamos procesando tu orden</p>
             <div className="action">
                 <a className="btn order" data-loading-text={this.state.loadingOrderText} onClick={this.openPayment} >Hacer Pedido</a>
             </div>

         </div>
       </div>
      </div>
      }
      {!this.state.payment &&   <Payment  cart={this.openCart.bind(this)} continue={this.stepBack.bind(this)}  error={this.state.error} loadingOrder={this.state.loadingOrderText} showProducts={this.props.showProducts}  shippingValue={this.props.shippingValue}  total={this.state.total}  products={this.props.couponData.products} cc={this.props.couponData.cc_only} paymentData={this.handlePaymentData.bind(this)}> </Payment> }
 </section>
    );
  }
}


export default Checkout;



// WEBPACK FOOTER //
// ./src/components/checkout/Checkout.js